/* K-Beauty Store, landingspagina CRO. Registreert de lp-* secties bij KBHome (home-cro.js).
   Geen libraries. Wacht tot home-cro.js geladen is. */
(function () {
  'use strict';
  function ready(fn) { if (window.KBHome && window.KBHome.register) return fn(window.KBHome); var n = 0; var t = setInterval(function () { if (window.KBHome && window.KBHome.register) { clearInterval(t); fn(window.KBHome); } else if (++n > 200) { clearInterval(t); } }, 25); }

  ready(function (KB) {
    if (KB._lpLoaded) return;
    KB._lpLoaded = true;
    var qs = KB.qs, qsa = KB.qsa, track = KB.track;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* Reveal: sectie krijgt is-in zodra hij in beeld komt */
    function reveal(el) {
      if (reduced || !('IntersectionObserver' in window)) { el.classList.add('is-in'); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { el.classList.add('is-in'); io.disconnect(); } });
      }, { rootMargin: '0px 0px -8% 0px' });
      io.observe(el);
    }

    KB.register('lp-hero', function (root) { reveal(root); });
    KB.register('lp-expect', function (root) { reveal(root); });

    /* Uitleg: video afspelen in de still */
    KB.register('lp-reveal', function (root) {
      reveal(root);
      var box = qs('[data-lp-video]', root);
      if (!box) return;
      var play = qs('[data-lp-play]', box);
      if (!play) return;
      play.addEventListener('click', function () {
        var url = box.getAttribute('data-video-url');
        if (!url) return;
        var v = document.createElement('video');
        v.src = url; v.controls = true; v.playsInline = true; v.autoplay = true;
        box.appendChild(v);
        play.hidden = true;
        qsa('.lp-video__shade, .lp-video__foot, .lp-video__badge', box).forEach(function (e) { e.hidden = true; });
        var p = v.play(); if (p && p.catch) p.catch(function () {});
        track('lp-explain', 'video_play', url);
      });
    });

    /* Volgorde: lagen wisselen */
    KB.register('lp-order', function (root) {
      reveal(root);
      var layers = qsa('[data-lp-layer]', root);
      function activate(btn) {
        layers.forEach(function (l) { var on = l === btn; l.classList.toggle('is-on', on); l.setAttribute('aria-expanded', on ? 'true' : 'false'); });
      }
      layers.forEach(function (l) {
        l.addEventListener('click', function () { activate(l); track('lp-order', 'layer', l.querySelector('strong') ? l.querySelector('strong').textContent : ''); });
        l.addEventListener('mouseenter', function () { if (window.matchMedia('(hover: hover)').matches) activate(l); });
      });
    });

    /* Producten: meer/minder */
    KB.register('lp-products', function (root) {
      reveal(root);
      var btn = qs('[data-lp-toggle]', root);
      if (!btn) return;
      var open = false;
      btn.addEventListener('click', function () {
        open = !open;
        qsa('[data-lp-more]', root).forEach(function (el) { el.hidden = !open; });
        btn.textContent = open ? btn.getAttribute('data-label-less') : btn.getAttribute('data-label-more');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (!open) { var grid = qs('[data-lp-grid]', root); if (grid) grid.scrollIntoView({ block: 'start', behavior: reduced ? 'auto' : 'smooth' }); }
        track('lp-products', open ? 'show_all' : 'show_less', '');
      });
    });

    /* Vergelijk: dots voor de mobiele snap-rij */
    KB.register('lp-compare', function (root) {
      reveal(root);
      var wrap = qs('[data-lp-cmp]', root); if (!wrap) return;
      var tr = qs('[data-lp-cmp-track]', wrap), dots = qs('[data-lp-cmp-dots]', wrap);
      if (!tr || !dots) return;
      var cards = qsa('.lp-cmp-m__card', tr);
      cards.forEach(function () { var d = document.createElement('span'); dots.appendChild(d); });
      function update() {
        var w = tr.scrollWidth / Math.max(1, cards.length);
        var i = Math.round(tr.scrollLeft / w);
        qsa('span', dots).forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      }
      tr.addEventListener('scroll', update, { passive: true });
      update();
    });

    /* FAQ: één open tegelijk */
    KB.register('lp-faq', function (root) {
      reveal(root);
      var items = qsa('.lp-faq__item', root);
      items.forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (d.open) { items.forEach(function (o) { if (o !== d && o.open) o.open = false; }); track('lp-faq', 'open', d.querySelector('summary') ? d.querySelector('summary').textContent.trim() : ''); }
        });
      });
    });
  });
})();
